import { Text, Container, rem, Stack, useMantineTheme } from '@mantine/core';
import { createStyles } from '@mantine/emotion';
import { LocaleSwitcher } from './LocaleSwitcher';
import { t } from 'ttag';

const useStyles = createStyles((theme, p, u) => ({
  footer: {
    marginTop: 0, //rem(120),
    paddingTop: `calc(${theme.spacing.xl} * 2)`,
    paddingBottom: `calc(${theme.spacing.xl})`,
    backgroundColor: theme.colors.gray[0],
  },

  logo: {
    [u.smallerThan('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  description: {
    marginTop: rem(5),

    [u.smallerThan('sm')]: {
      marginTop: theme.spacing.xs,
      textAlign: 'center',
    },
  },

  inner: {
    display: 'flex',
    justifyContent: 'space-between',

    [u.smallerThan('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  groups: {
    display: 'flex',
    flexWrap: 'wrap',

    [u.smallerThan('sm')]: {
      paddingTop: theme.spacing.xl,
    },
  },

  wrapper: {
    width: rem(160),
  },

  link: {
    display: 'block',
    color: theme.colors.gray[6],
    fontSize: theme.fontSizes.sm,
    paddingTop: rem(3),
    paddingBottom: rem(3),

    [u.smallerThan('sm')]: {
      textAlign: 'center',
    },

    '&:hover': {
      textDecoration: 'underline',
    },
  },

  title: {
    fontSize: theme.fontSizes.lg,
    fontWeight: 700,
    marginBottom: `calc(${theme.spacing.xs} / 2)`,
    color: theme.black,

    [u.smallerThan('sm')]: {
      textAlign: 'center',
    },
  },

  afterFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing.xl,
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
    borderTop: `${rem(1)} solid ${theme.colors.gray[2]}`,

    [u.smallerThan('sm')]: {
      flexDirection: 'column',
    },
  },

  social: {
    [u.smallerThan('sm')]: {
      marginTop: theme.spacing.xs,
    },
  },
}));

interface PageFooterProps {
  data: {
    title: string;
    links: { label: string; link: string }[];
  }[];
}

export const PageFooter = ({ data }: PageFooterProps) => {
  const { classes } = useStyles();

  const groups = data.map((group) => {
    const links = group.links.map((link, index) => (
      <Text<'a'> key={index} className={classes.link} component="a" href={link.link}>
        {link.label}
      </Text>
    ));

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <footer className={classes.footer}>
      <Container className={classes.inner}>
        <Stack className={classes.logo}>
          <img src="grantme_dark_transparent.png" width={180} />
          <Text size="xs" c="dimmed" className={classes.description}>
            {t`Hantera ansökningar, smidigare än någonsin!`}
          </Text>
        </Stack>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Container className={classes.afterFooter}>
        <Text c="dimmed" size="sm">
          © {new Date().getFullYear()} Grantme AB
        </Text>
        <LocaleSwitcher withText />
      </Container>
    </footer>
  );
};
